import { ActionTree } from 'vuex'

import { MultiUserState, RootState } from '@/types/store'

import {
  createMultiUser,
  deleteMultiUser,
  getMultiUsers,
  updateMultiUser,
} from '@/api/users'

import { IUser, UserRole } from '@/types/user'

export const actions: ActionTree<MultiUserState, RootState> = {
  async createMultiUser({ commit }, user: IUser): Promise<void> {
    const created = await createMultiUser(user)
    commit('createMultiUser', created)
  },
  async getMultiUsers({ commit }, data?: any): Promise<void> {
    const { lastId, ...query } = data
    commit('multiUsersLoaded', [])
    commit('multiUsersLoadStart', true)
    const multiUsers = await getMultiUsers(lastId, query)
    commit('multiUsersLoaded', multiUsers)
  },
  async getMultiUser({ commit }, multiuser: IUser): Promise<void> {
    commit('setMultiUser', multiuser)
  },
  async setNewMultiUser({ commit }): Promise<void> {
    const notice: IUser = {
      id: -1,
      role: UserRole.LINKER,
      code: '',
      castId: '',
      castName: '',
      mail: '',
      password: '',
      isValid: true,
      isRewarded: false,
      createdAt: new Date(),
      updatedAt: new Date(),
      deletedAt: null,
    }
    commit('setMultiUser', notice)
  },
  async updateMultiUser({ commit }, multiUser: IUser): Promise<string> {
    // return error
    try {
      multiUser = await updateMultiUser(multiUser)
      commit('updateMultiUser', multiUser)
      return ''
    } catch (error) {
      return error
    }
  },
  async deleteMultiUser({ commit }, id: number): Promise<void> {
    await deleteMultiUser(id)
    commit('deleteMultiUser', id)
  },
}
